import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatEventDate } from "../../lib/api";
import { Plus, PencilSimple, Trash } from "@phosphor-icons/react";

const AdminEvents = () => {
  const [events, setEvents] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/events").then(({ data }) => setEvents(data));
  useEffect(() => { load(); }, []);

  const createNew = async () => {
    setBusy(true);
    try {
      const payload = {
        title: "Untitled event",
        tagline: "Edit me",
        description: "Edit me.",
        date: new Date(Date.now() + 30 * 24 * 3600 * 1000).toISOString(),
        location: "TBD",
        venue: "TBD",
        city: "TBD",
        capacity: 100,
        status: "draft",
        featured: false,
        agenda: [],
        speakers: [],
        questions: [],
      };
      const { data } = await api.post("/admin/events", payload);
      window.location.href = `/admin/events/${data.id}`;
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this event and all RSVPs?")) return;
    await api.delete(`/admin/events/${id}`);
    load();
  };

  return (
    <div data-testid="admin-events-page">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="term-label">/ events</div>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl mt-2">All events.</h1>
        </div>
        <button onClick={createNew} disabled={busy} className="btn-neon" data-testid="create-event-btn">
          <Plus size={14} weight="bold" /> {busy ? "Creating..." : "New event"}
        </button>
      </div>

      <div className="hard-border">
        <div className="grid grid-cols-12 gap-2 px-5 py-3 border-b border-cyber-line bg-cyber-elevated font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/60">
          <div className="col-span-4">Title</div>
          <div className="col-span-2">Date</div>
          <div className="col-span-2">City</div>
          <div className="col-span-2">Status</div>
          <div className="col-span-2 text-right">Actions</div>
        </div>
        {events.length === 0 && <div className="px-5 py-8 text-white/50 font-mono-tech">/ no events yet.</div>}
        {events.map((e) => (
          <div key={e.id} className="grid grid-cols-12 gap-2 px-5 py-4 border-b border-cyber-line items-center" data-testid={`event-row-${e.id}`}>
            <div className="col-span-4">
              <div className="text-white">{e.title}</div>
              <div className="font-mono-tech text-xs text-white/40">/{e.slug}</div>
            </div>
            <div className="col-span-2 font-mono-tech text-xs text-white/70">{formatEventDate(e.date)}</div>
            <div className="col-span-2 font-mono-tech text-xs text-white/70">{e.city}</div>
            <div className="col-span-2">
              <span className={`font-mono-tech text-xs px-2 py-1 border ${e.status === 'published' ? 'border-cyber-green text-cyber-green' : 'border-white/30 text-white/60'}`}>{e.status}</span>
              {e.featured && <span className="font-mono-tech text-xs px-2 py-1 ml-2 border border-cyber-yellow text-cyber-yellow">★</span>}
            </div>
            <div className="col-span-2 flex items-center justify-end gap-3">
              <Link to={`/admin/events/${e.id}`} data-testid={`edit-${e.id}`} className="text-cyber-yellow hover:text-white"><PencilSimple size={16} /></Link>
              <button onClick={() => remove(e.id)} data-testid={`delete-${e.id}`} className="text-cyber-red hover:text-white"><Trash size={16} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminEvents;
